import { OrderType, TriggerType, TriggerTypeBase } from "../index.js";
const OrderTypeCaption = {
  [OrderType.ENTER]: "\uC9C4\uC785",
  [OrderType.EXIT]: "\uCCAD\uC0B0"
};
const TriggerTypeBaseCaption = {
  [TriggerTypeBase.SIGNAL]: "\uC2E0\uD638",
  [TriggerTypeBase.TRAILING]: "\uCD94\uC801",
  [TriggerTypeBase.EXCLUSIVE]: "\uAD6C\uAC04",
  [TriggerTypeBase.OVERLAPPING]: "\uB2E8\uACC4",
  [TriggerTypeBase.FORCED]: "\uAC15\uC81C"
};
const UserTriggerTypeCaption = {
  [TriggerType.SIGNAL_ENTER]: `${TriggerTypeBaseCaption[TriggerTypeBase.SIGNAL]} ${OrderTypeCaption[OrderType.ENTER]}`,
  [TriggerType.SIGNAL_EXIT]: `${TriggerTypeBaseCaption[TriggerTypeBase.SIGNAL]} ${OrderTypeCaption[OrderType.EXIT]}`,
  [TriggerType.TRAILING_EXIT]: `${TriggerTypeBaseCaption[TriggerTypeBase.TRAILING]} ${OrderTypeCaption[OrderType.EXIT]}`,
  [TriggerType.EXCLUSIVE_EXIT]: `${TriggerTypeBaseCaption[TriggerTypeBase.EXCLUSIVE]} ${OrderTypeCaption[OrderType.EXIT]}`,
  [TriggerType.OVERLAPPING_EXIT]: `${TriggerTypeBaseCaption[TriggerTypeBase.OVERLAPPING]} ${OrderTypeCaption[OrderType.EXIT]}`
};
const TriggerTypeCaption = {
  ...UserTriggerTypeCaption,
  [TriggerType.FORCED_EXIT]: `\uAC15\uC81C ${OrderTypeCaption[OrderType.EXIT]}`
};
var ko_default = {
  OrderTypeCaption,
  TriggerTypeBaseCaption,
  UserTriggerTypeCaption,
  TriggerTypeCaption
};
export {
  OrderTypeCaption,
  TriggerTypeBaseCaption,
  TriggerTypeCaption,
  UserTriggerTypeCaption,
  ko_default as default
};
//# sourceMappingURL=ko.js.map
